import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Login } from '../login/login.component';
import { Main } from '../main/main.component';
import { Home } from '../home/home.component';
import { CreatedCustomer } from '../created-customer/created-customer.component';
import { Customer } from '../customer/customer.component';
import { Products } from '../products/products.component';
import { Providers } from '../providers/providers.component';
import { Provider } from '../provider/provider.component';
import { BankAccounts } from '../bank-accounts/bank-accounts.components';
import { BankAccount } from '../bank-account/bank-account.component';
import { Banks } from '../banks/banks.component';
import { Bank } from '../bank/bank.component';
import { AppReleases } from '../app-releases/app-releases.component';
import { Finances } from '../finances/finances.component';
import { NotFound } from '../not-found/not-found.component';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/login' element={<Login/>}/>
        <Route path='/' element={<Main/>}>
          <Route index element={<Home/>}/>
          <Route path='/customer/:id' element={<Customer/>}/>
          <Route path='/created-customer' element={<CreatedCustomer/>}/>
          <Route path='/products' element={<Products/>}/>
          <Route path='/bank-accounts' element={<BankAccounts/>}/>
          <Route path='/bank-account/:id' element={<BankAccount/>}/>
          <Route path='/banks' element={<Banks/>}/>
          <Route path='/bank/:id' element={<Bank/>}/>
          <Route path='/providers' element={<Providers/>}/>
          <Route path='/provider/:id' element={<Provider/>}/>
          <Route path='/finances' element={<Finances/>}/>
          <Route path='/app-releases' element={<AppReleases/>}/>
        </Route>
        <Route path='*' element={<NotFound/>} />
      </Routes>
    </BrowserRouter>
  );
}
